/* קריאה לשרת שלנו (/api/ai), שמחזיק את מפתח ה-API ומוודא שהמשתמש מחובר */
import { accessToken } from './supabase.js';

/**
 * @param {'scan'|'classify'} task
 * @param {string} prompt
 * @param {{data:string, mediaType:string}} [file] base64
 * @returns {Promise<string>} הטקסט שהמודל החזיר
 */
export async function askAI(task, prompt, file) {
  const token = await accessToken();
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 180000);
  let r;
  try {
    r = await fetch('/api/ai', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ task, prompt, file }),
      signal: ctrl.signal,
    });
  } catch (e) {
    throw new Error(e.name === 'AbortError' ? 'הניתוח ארך יותר מדי' : 'שגיאת רשת');
  } finally {
    clearTimeout(timer);
  }
  let j = {};
  try { j = await r.json(); } catch { /* תשובה לא תקינה */ }
  if (!r.ok) throw new Error(j.error || 'שגיאת שרת ' + r.status);
  return j.text || '';
}

/** קובץ ל-base64 (בלי הקידומת data:) */
export function fileToBase64(file) {
  return new Promise((res, rej) => {
    const rd = new FileReader();
    rd.onload = () => res(String(rd.result).split(',')[1]);
    rd.onerror = () => rej(new Error('שגיאה בקריאת הקובץ'));
    rd.readAsDataURL(file);
  });
}
